import { useStore } from '@stores';
import { useEffect } from 'react';

export const useTwoFactorStatus = () => {
  const { twoFactorStore } = useStore();

  useEffect(() => {
    twoFactorStore.loadStatus();
  }, [twoFactorStore]);

  return {
    status: twoFactorStore.status,
    isEnabled: twoFactorStore.isEnabled,
    method: twoFactorStore.method,
    trustedDevices: twoFactorStore.trustedDevices,
    loading: twoFactorStore.loading,
  };
};
